<template>
  <v-dialog max-width="350px" v-model="dialog">
    <v-overlay v-if="loading">
      <v-progress-circular indeterminate color="primary"/>
    </v-overlay>
    <v-card>
      <v-card-title/>
      <v-card-text>
        <v-row dense>
          <v-col cols="12">
            <r-global-config-dropdown :model.sync="selected"/>
          </v-col>
        </v-row>
      </v-card-text>
      <v-card-actions>
        <v-spacer/>
        <v-btn @click="cancel" color="blue darken-1" text>Cancel</v-btn>
        <v-btn @click="apply" color="blue darken-1" text>Apply</v-btn>
      </v-card-actions>
    </v-card>
    <template v-slot:activator="{ on }">
      <v-text-field v-model.trim="name" label="Global Config" v-on="on" readonly hide-details/>
    </template>
  </v-dialog>
</template>

<script>

import {RedactorUtils} from "@/modules/redactor/core/RedactorUtils";

import RGlobalConfigDropdown from "@/modules/redactor/views/global-config/r-global-config-dropdown.vue";

export default {
  name: "r-global-config-view",
  components: {RGlobalConfigDropdown},
  data: () => ({
    dialog: false,
    loading: false,
    selected: null
  }),
  methods: {
    apply() {
      let uid_current = this.current ? this.current.uid : "";
      let uid_selected = this.selected ? this.selected.uid : "";

      if (uid_current !== uid_selected) {
        this.loading = true;

        RedactorUtils.switchGlobalConfig(uid_selected).finally(() => {
          this.loading = false;
          this.discard();
        });
      } else {
        this.discard();
      }
    },
    cancel() {
      this.discard();
    },
    discard() {
      this.dialog = false;
    }
  },
  computed: {
    name() {
      return this.current ? this.current.name : "";
    },
    current() {
      return RedactorUtils.getGlobalConfig();
    }
  },
  watch: {
    dialog(value) {
      if (value) {
        this.selected = this.current;
      }
    }
  }
}
</script>